import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {SuppliersListHeader} from './components/header/SuppliersListHeader'
import {SuppliersTable} from './table/SuppliersTable'
import { SupplierEditModal } from './Supplier-edit-modal/SupplierEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const SuppliersList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <SuppliersListHeader />
        <SuppliersTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <SupplierEditModal />}
    </>
  )
}

const SuppliersListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <SuppliersList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {SuppliersListWrapper}
